import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRequiredUserAttributes, getUserData } from '../../../../../../adapters';

const USER_ACTION_TYPES = {
    FETCH_USER: 'userData/fetchUser',
    FETCH_USER_ATTRIBUTES: 'userdata/fetchUserAttributes'
};

export const getUserDetails = createAsyncThunk(USER_ACTION_TYPES.FETCH_USER, async () => {
    const result = await getUserData();
    if (result) {
        return {
            data: { ...result, loginMethod: 'mobile' }
        };
    } else {
        throw new Error('Unable to fetch user details');
    }
});

export const getUserAttributes = createAsyncThunk(
    USER_ACTION_TYPES.FETCH_USER_ATTRIBUTES,
    async ({ userId }: { userId: string }) => {
        const result = await getRequiredUserAttributes(userId);
        return result ?? null;
    }
);
